/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-27 19:30:38
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2019-12-31 01:06:21
 * @Description: file content
 * http://actapi.ruthyx.com/yq-auth/web/userAuth/getUserInfo
 */
export default {
  protocol: "",
  domain: "",
  action: {
    getUserInfo: "/yq-auth/web/userAuth/getUserInfo",
    paymentUrl: "/pay/WXPayAction/paymentUrl", //微信支付需要的接口
  }
}